import {
	DROP_UPLOAD_CODES_FORM_MODULE_ID,
	PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import { dropUploadCodes } from 'root/src/client/logic/tableItem/thunks/dropUploadCodes'
import dropUploadCodesOnSuccess	from 'root/src/client/logic/tableItem/thunks/dropUploadCodesOnSuccess'
import { readFileAsText } from 'root/src/shared/util/readFileAsText'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'

export default {
	[DROP_UPLOAD_CODES_FORM_MODULE_ID]: [
		{
			action: formData => async (dispatch, getState) => {
				const formFile = formData?.csvCodes?.file

				if (!formFile) {
					throw { csvCodes: 'Codes file is required' }
				}

				const fileOutput = await readFileAsText(formFile)

				const codesArray = fileOutput.split('\n')

				return new Promise((resolve, reject) => dispatch(
					displayModal(
						PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID, {
							rewards: codesArray,
							onSubmit: () => resolve(dropUploadCodes(formData)(dispatch, getState)),
							// eslint-disable-next-line prefer-promise-reject-errors
							onClose: () => reject({ csvCodes: 'Codes were not added' }),
						},
					),
				))
			},
			onSuccess: dropUploadCodesOnSuccess,
		},
	],
}
